'use es6';

import { memo } from 'react';
import Small from 'UIComponents/elements/Small';
import UITruncateString from 'UIComponents/text/UITruncateString';
import parseNameHighlight from '../utils/parseNameHighlight';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HighlightedName = ({
  query,
  name
}) => {
  const parsedName = parseNameHighlight(name, query);
  if (!parsedName) {
    return /*#__PURE__*/_jsx(UITruncateString, {
      children: name || ''
    });
  }
  return /*#__PURE__*/_jsxs(UITruncateString, {
    tooltip: /*#__PURE__*/_jsxs(Small, {
      children: [parsedName.prefix, /*#__PURE__*/_jsx("span", {
        className: "highlighted-result-tooltip",
        children: parsedName.matched
      }), parsedName.suffix]
    }),
    children: [parsedName.prefix, /*#__PURE__*/_jsx("span", {
      className: "highlighted-result",
      children: parsedName.matched
    }), parsedName.suffix]
  });
};
export default /*#__PURE__*/memo(HighlightedName);